import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import tippy from 'tippy.js'; // These props are not native to `tippy.js` and are specific to React only.

var REACT_ONLY_PROPS = ['children', 'onCreate', 'isVisible', 'isEnabled'];
/** Avoid Babel's large '_objectWithoutProperties' helper function.
 *
 * @param {object} props - Props object
 */

function getNativeTippyProps(props) {
  return Object.keys(props).filter(function (prop) {
    return !REACT_ONLY_PROPS.includes(prop);
  }).reduce(function (acc, key) {
    acc[key] = props[key];
    return acc;
  }, {});
}

var PopoverBase =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PopoverBase, _React$Component);

  function PopoverBase() {
    var _this;

    _classCallCheck(this, PopoverBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopoverBase).apply(this, arguments));
    _this.state = {
      isMounted: false
    };
    _this.container = typeof document !== 'undefined' && document.createElement('div');
    return _this;
  }

  _createClass(PopoverBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
      /* eslint-disable-next-line */

      this.tip = tippy(ReactDOM.findDOMNode(this), this.options);
      var _this$props = this.props,
          onCreate = _this$props.onCreate,
          isEnabled = _this$props.isEnabled,
          isVisible = _this$props.isVisible;

      if (onCreate) {
        onCreate(this.tip);
      }

      if (isEnabled === false) {
        this.tip.disable();
      }

      if (this.isManualTrigger && isVisible === true) {
        this.tip.show();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.tip.setProps(this.options);
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          isVisible = _this$props2.isVisible;

      if (isEnabled === true) {
        this.tip.enable();
      }

      if (isEnabled === false) {
        this.tip.disable();
      }

      if (this.isManualTrigger) {
        if (isVisible === true) {
          this.tip.show();
        }

        if (isVisible === false) {
          this.tip.hide();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.tip.destroy();
      this.tip = null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.props.children, this.isReactElementContent && this.state.isMounted && ReactDOM.createPortal(this.props.content, this.container));
    }
  }, {
    key: "isReactElementContent",
    get: function get() {
      return React.isValidElement(this.props.content);
    }
  }, {
    key: "options",
    get: function get() {
      return Object.assign(Object.assign({}, getNativeTippyProps(this.props)), {
        content: this.isReactElementContent ? this.container : this.props.content
      });
    }
  }, {
    key: "isManualTrigger",
    get: function get() {
      return this.props.trigger === 'manual';
    }
  }]);

  return PopoverBase;
}(React.Component);

PopoverBase.defaultProps = {
  trigger: 'mouseenter focus'
};
export default PopoverBase;